import { render, staticRenderFns } from "./configCategotyEdit.vue?vue&type=template&id=fc987ccc"
import script from "./configCategotyEdit.vue?vue&type=script&lang=js"
export * from "./configCategotyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc987ccc')) {
      api.createRecord('fc987ccc', component.options)
    } else {
      api.reload('fc987ccc', component.options)
    }
    module.hot.accept("./configCategotyEdit.vue?vue&type=template&id=fc987ccc", function () {
      api.rerender('fc987ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/devconfig/configCategotyEdit.vue"
export default component.exports